import { useEffect } from 'react'
import { useAppDispatch, useAppSelector } from '@/store/store-hooks'
import { RootState } from '@/store/store'
import { MedChronAssetActions } from '../store/slice'

type MedChronAssetRootProps = {
  children: React.ReactNode
}

/**
 * Root wrapper for all medical chronology routes.
 * Loads the active matter's living chronology (and resumes any in-flight update polling).
 */
export default function MedChronAssetRoot({ children }: MedChronAssetRootProps) {
  const dispatch = useAppDispatch()
  const activeMatterId = useAppSelector((state: RootState) => state.mattersState.activeMatterId)

  useEffect(() => {
    if (activeMatterId) {
      dispatch(MedChronAssetActions.fetchAssetForMatter({ matterId: activeMatterId }))
    }
  }, [dispatch, activeMatterId])

  return <>{children}</>
}
